import React from 'react';
import './ProgressBar.css';
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { truncate } from 'lodash';

const ProgressBar = ({ donationCollected, goalAmount, totalDonors, highestDonation, title }) => {
  // Calculate the progress percentage
  const progressPercentage = (donationCollected / goalAmount) * 100;
  const {t} = useTranslation()

  return (
    <div className="progress-section">
      <div className="progress-bar-container">
        <p style={{fontSize:'20px',fontWeight:500, color:'#7E7E7E', marginBottom:'24px', textAlign:'left'}}><span style={{color:'#00AC4F', fontWeight:700}}>&euro;{donationCollected} {t('raised')}</span> {t('out of')} &euro;{goalAmount}</p>
        <div className="progress-bar">
          <div
            className="progress-bar-fill"
            style={{ width: `${progressPercentage}%` }} // Dynamically set width
          >
          </div>
          <div
            className="progress-bar-label"
            style={{ left: `${progressPercentage}%` }} // Adjust the label position
          >
            €{donationCollected}
          </div>
        </div>
      </div>

      <div className="progress-info">
        <div>{progressPercentage.toFixed(1)}% {t('completed')}</div>
        <div>{totalDonors} {t("donations")}</div>
      </div>
    </div>
  );
};

export default ProgressBar;
